import { render, staticRenderFns } from "./SVGAdminOrganizations.vue?vue&type=template&id=5249c988&scoped=true&"
import script from "./SVGAdminOrganizations.vue?vue&type=script&lang=js&"
export * from "./SVGAdminOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249c988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5249c988')) {
      api.createRecord('5249c988', component.options)
    } else {
      api.reload('5249c988', component.options)
    }
    module.hot.accept("./SVGAdminOrganizations.vue?vue&type=template&id=5249c988&scoped=true&", function () {
      api.rerender('5249c988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGAdminOrganizations.vue"
export default component.exports